import { __rest } from "tslib";
import * as React from 'react';
// tslint:disable-next-line:import-blacklist
import { Route } from 'react-router-dom';
import { Redirect } from '@shared/routing';
const ProtectedRoute = (_a) => {
    var { isAccessible, redirectTo } = _a, props = __rest(_a, ["isAccessible", "redirectTo"]);
    return (React.createElement(Route, Object.assign({}, props, { render: componentProps => (isAccessible ? props.render(componentProps) : React.createElement(Redirect, { to: redirectTo })) })));
};
export default ProtectedRoute;
